export default "__VITE_ASSET__CNwxVuti__"